/**
 * Initiates a popover close button.
 * Used in conjunction w/ the bootstrap popover component.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["popover"];

  close(e) {
    e.preventDefault();

    if (this.hasPopoverOutlet) {
      this.popoverOutlet.hide();
    }
  }
}
